import actions from './actions'
import types from '../types'
import { logGaNonInteractionEvent } from 'common/utils/analytics'
import apiManager from 'tickets/utils/apiManager'

const fetchPassengerOptions = (origin, destination) => (dispatch) =>
  apiManager.schedulesConfig(origin, destination)
    .then((response) => {
      dispatch({
        type: types.PASSENGER_OPTIONS_DATA_RECEIVED,
        payload: response.data,
      })
      logGaNonInteractionEvent(
        'Tickets', 'API:Config', 'Success'
      )
    })
    .catch((error) => {
      logGaNonInteractionEvent(
        'Tickets', 'API:Config', `Error:${error}`
      )
    })

const minusPassenger = actions.minusPassenger
const addPassenger = actions.addPassenger
const removeExactPassenger = actions.removeExactPassenger
const updatePassenger = actions.updatePassenger
const updatePax = actions.updatePax
const passengerOptionsReceived = actions.passengerOptionsReceived

export default {
  fetchPassengerOptions,
  minusPassenger,
  addPassenger,
  removeExactPassenger,
  updatePassenger,
  updatePax,
  passengerOptionsReceived,
}
